@for (link of links(); track link) {
  <app-side-menu-button
    [icon]="link.icon"
    [label]="link.label | translate"
    [url]="link.url"
  />
}
